import React, { useEffect, useState } from 'react';
import Sorting from "../../../assets/images/icons/sort.png";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { DataGrid } from "@mui/x-data-grid";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import Button from "@mui/material/Button";
import AddStakeholders from "./addStakeholders";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import EditIcon from '@mui/icons-material/Edit';
import { Action, DefaultPerPageValue, PerPage } from '../../../constants/Common';
import { useParams } from 'react-router-dom';
import { deleteStakeholder, getStakeholderList } from '../../../api/casp/stakeholder';
import SweetAlert from 'react-bootstrap-sweetalert';
import { toast } from "react-toastify";
import Search from '../common/Search';
import { hasModulePermission } from '../../../helpers/permission';
import { Modules } from '../../../constants/Module';
import { withTranslation } from "react-i18next";
import { PaginationComponent } from '../common/PaginationComponent';

function Stakeholders({ disabled, t }) {
    const [openStakeHolderModal, setOpenStakeHolderModal] = useState(false);
    const { project } = useParams();
    const [page, setPage] = useState(0);
    const [totalRows, setTotalRows] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [isLoading, setIsLoading] = useState(false);
    const [stakeholderList, setStakeholderList] = useState([]);
    const [action, setAction] = useState(Action.CREATE);
    const [stakeholderDetails, setStakeholderDetails] = useState({});
    const [stakeholderId, setStakeholderId] = useState();
    const [isOpenSweetAlert, setIsOpenSweetAlert] = useState(false)
    const hasCreatePermissionForStakeholder = hasModulePermission(Modules.STAKEHOLDER, Action.CREATE)
    const hasEditPermissionForStakeholder = hasModulePermission(Modules.STAKEHOLDER, Action.EDIT)
    const hasDeletePermissionForStakeholder = hasModulePermission(Modules.STAKEHOLDER, Action.DELETE)
    const [dynamicColumn, setDynamicColumn] = useState([]);

    const getRowId = (row) => row.id;
    const columns = [
        {
            field: "index",
            headerName: "#",
            width: 100,
            filterable: false,
            sortable: false
        },
        {
            field: "name",
            headerName: t("Name"),
            width: 200,
            filterable: false,
            sortable: false
        },
        {
            field: "email",
            headerName: t("Email"),
            width: 200,
            filterable: false,
            sortable: false
        },
        {
            field: "communicationState",
            headerName: t("State of Communication"),
            width: 200,
            filterable: false,
            sortable: false
        },
        {
            field: "group",
            headerName: t("Group"),
            width: 200,
            filterable: false,
            sortable: false
        },
        // {
        //     field: "type",
        //     headerName: t("Type"),
        //     width: 200,
        //     filterable: false,
        //     sortable: false,
        //     valueGetter: (params) => {
        //         if (params.value === 'others') {
        //             return params.row.customType;
        //         }
        //         return params.value;
        //     },
        // },
        {
            field: "contactNo",
            headerName: t("Contact No."),
            width: 200,
            filterable: false,
            sortable: false,
        },
        {
            field: "actions",
            headerName: t("Actions"),
            width: 150,
            sortable: false,
            filterable: false,
            hideable: false,
            renderCell: (params) => (
                <div className="proSubmissionActions" style={{ cursor: 'pointer' }}>
                    {
                        hasDeletePermissionForStakeholder &&
                        <DeleteOutlineOutlinedIcon onClick={() => {
                            setStakeholderId(params.row.id)
                            setIsOpenSweetAlert(true)
                        }}
                            style={{ cursor: !disabled ? 'pointer' : 'not-allowed' }}
                        />
                    }
                    {
                        hasEditPermissionForStakeholder &&
                        <EditIcon onClick={(e) => {
                            e.preventDefault()
                            setAction(Action.EDIT)
                            setStakeholderDetails(params.row)
                            setOpenStakeHolderModal(true)
                        }} style={{ cursor: !disabled ? 'pointer' : 'not-allowed' }} />
                    }
                </div>
            ),
        },
    ];

    useEffect(() => {
        if (!hasDeletePermissionForStakeholder || !hasEditPermissionForStakeholder) {
            setDynamicColumn(columns.filter((eachColumn) => eachColumn.field !== "actions"))
        }
        else {
            setDynamicColumn(columns)
        }
    }, [])

    const handleOpenstakeholderPopup = () => {
        setOpenStakeHolderModal(true);
    };

    const handleCloseChallengesPopup = () => {
        setOpenStakeHolderModal(false);
        setAction(Action.CREATE)
        setStakeholderDetails({})
    };
    const handelDelete = async () => {
        setIsOpenSweetAlert(false)
        try {
            setIsLoading(true)
            const res = await deleteStakeholder(stakeholderId, { projectId: parseInt(project) })
            toast.success(res.data.message)
            refetch()
            setStakeholderId()
        } catch (err) {
            toast.error(err.message)
        }
        finally {
            setStakeholderId()
        }
    }
    useEffect(() => {
        fetchStakeholderList({ page, perPage: rowsPerPage });
    }, [page, rowsPerPage])
    const refetch = async (params = {}) => {
        await fetchStakeholderList(params)
    }
    const fetchStakeholderList = async (params = {}) => {
        setIsLoading(true)
        try {
            if (params) {
                params = {
                    ...params,
                    page: page + 1,
                    perPage: rowsPerPage,
                    projectId: project
                };
            } else {
                params = {
                    page: page + 1,
                    perPage: rowsPerPage,
                    projectId: project
                };
            }
            let level = ((page + 1) - 1) * rowsPerPage
            const res = (await getStakeholderList(params)).data.data;
            if (res.data.length > 0) {
                setStakeholderList(res.data.map((stakeholder) => ({
                    index: ++level,
                    id: stakeholder.id,
                    name: stakeholder.name,
                    email: stakeholder.email,
                    // entity: stakeholder.entity,
                    group: stakeholder.group,
                    communicationState: stakeholder.communicationState,
                    // customType: stakeholder.customType,
                    contactNo: stakeholder.contactNo
                })));
                setTotalRows(res.meta.total);
            } else {
                setStakeholderList([]);
                setTotalRows(0);
            }
        } catch (error) {
            setIsLoading(false)
            console.log(error)
        } finally {
            setIsLoading(false);
        }
    }
    const handlePaginationModelChange = (data) => {
        setPage(data.page);

        if (rowsPerPage !== data.pageSize) {
            setRowsPerPage(data.pageSize);
        }
    };

    const globalSearch = async (params) => {
        setPage(0);
        setStakeholderList([]);
        fetchStakeholderList({ search: params.search });
    };

    return (
        <div className="projectSubmission teamTable customTabCard">
            <div className="mainPageHeader d-flex justify-content-between mb-4">
                <BreadCrumb title={t("Offtaker Details")} />
                <div className='d-flex justify-content-end'>
                    <div className="filterTitle d-flex align-items-center mx-2 taskHeaderSearchField">
                        <Search listCall={globalSearch} />
                    </div>
                    {
                        !disabled && hasCreatePermissionForStakeholder &&
                        <Button
                            variant="contained"
                            startIcon={<AddOutlinedIcon />}
                            className="popupButton edit_button main-login-btn btn btn-secondary d-flex align-items-center btn btn-secondary"
                            disableElevation
                            onClick={handleOpenstakeholderPopup}
                        >
                            {t("Add Offtaker")}
                        </Button>
                    }
                </div>
            </div>
            <div className="projectTypeTable my-4" style={{ height: 400, width: "100%", border: 'none' }}>
                <DataGrid
                    rows={stakeholderList}
                    columns={dynamicColumn}
                    initialState={{
                        pagination: {
                            paginationModel: { pageSize: rowsPerPage },
                        },
                    }}
                    pageSizeOptions={PerPage}
                    disableRowSelectionOnClick
                    onPaginationModelChange={handlePaginationModelChange}
                    paginationMode="server"
                    rowCount={totalRows}
                    getRowId={getRowId}
                    loading={isLoading}
                    sortingMode="server"
                    localeText={{
                        noRowsLabel: t("No Offtaker available for this startup."),
                    }}
                    hideFooter={true}
                />
            </div>
            {stakeholderList.length > 0 && (
                <div className="ongoingProjPagination d-flex justify-content-end mt-3 newRoundedPagination">
                    <PaginationComponent
                        paginationObject={stakeholderList}
                        page={page}
                        handleChangePage={3}
                        rowsPerPage={rowsPerPage}
                        handleChangeRowsPerPage={5}
                    />
                </div>
            )}
            {openStakeHolderModal &&
                <AddStakeholders
                    action={action}
                    open={openStakeHolderModal}
                    stakeholderDetails={stakeholderDetails}
                    onClose={handleCloseChallengesPopup}
                    refetch={refetch}
                />
            }
            {isOpenSweetAlert && (
                <SweetAlert
                    title={t("Are you sure want to delete this Offtaker?")}
                    warning
                    showCancel
                    confirmBtnText={t("OK")}
                    cancelBtnText={t("Cancel")}
                    confirmBtnBsStyle="success"
                    cancelBtnBsStyle="danger"
                    onConfirm={() => {
                        handelDelete()
                    }}
                    onCancel={() => {
                        setIsOpenSweetAlert(false)
                    }}>
                </SweetAlert>
            )}
        </div>

    );
}
export default withTranslation()(Stakeholders);
